export default {
    'Menu': 'Меню'
};



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/core/oncanvas/translations/ru.js
// module id = 98
// module chunks = 0